import { Alert, Button, Fade, Grow, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import dayjs from "dayjs";
import { CheckIdBooking } from "../../utils/CheckIdBooking";
import { Fetching } from "../../components/Fetching";
import Modal from "react-modal";
import { ModalStyle } from "../../components/ModalStyle";
import OtpInput from "react-otp-input";
import xIcon from "../../images/xIcon.png";
import { ResendOTP, verifyOTP } from "./Component/OTP";
import { reqBooking } from "./Component/RequestBooking";
import { CheckTerminal } from "../../utils/CheckTerminal";
import CityShuttleCard from "../../components/CityShuttleCard";
import { ScheduleData } from "../../utils/ScheduleDetail";
import axios from "axios";
import { ApiUrl } from "src/utils/ApiUrl";

interface ApiFormField {
  id: number;
  bookingCode: string;
  customer: {
    name: string;
    email: string;
    contact: string;
  };
  adultTotal: number;
  childTotal: number;
  numberOfBags: number;
  pickUpTime: Date;
  time: string;
  flightNumber: string;
  type: string;
  scheduleId: number;
  bookingLocations: {
    address: {
      fullAddress: string;
    };
    description: string;
    name: string;
  }[];
  vehicleType: {
    price: number;
    name: string;
    seaters: number;
    id: number;
  };
  bookingStatus: string;
  paymentStatus: string;
  driverName: string;
  plateNumber: string;
  driverContact: string;
}

interface LocalFormField {
  name: string;
  email: string;
  from: string;
  to: string;
  date: Date;
  time: string;
  adults: number;
  childs: number;
  bags: number;
  contactnumber: string;
  arriving: string;
  airline: string;
  flightnumber: string;
  isFromAirport: boolean;
  descriptions: string;
  scheduleId: number;
}

const ShuttleBookingSummary = () => {
  var customParseFormat = require("dayjs/plugin/customParseFormat");
  dayjs.extend(customParseFormat);
  const [pageState, setPageState] = useState("");
  const [descriptions, setDescriptions] = useState("");
  const [fullAddressFrom, setFullAddressFrom] = useState("");
  const [fullAddressTo, setFullAddressTo] = useState("");
  const [isFetching, setIsFechting] = useState(true);
  const [price, setPrice] = useState(0);
  const [FetchingType, setFetchingType] = useState("");
  const [FetchingText, setFetchingText] = useState("LOADING");
  const [BookingIdData, setBookingIdData] = useState<ApiFormField>();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [OTPError, setOTPError] = useState(false);
  const [resendCodeText, setResendCodeText] = useState("Resend Code");
  const [resendCodeState, setResendCodeState] = useState(false);
  const [modalOTPIsOpen, setOTPIsOpen] = useState(false);
  const [FetchingBooking, setFetchingBooking] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMassage, setErrorMassage] = useState("");
  const params = useParams();
  let navigate = useNavigate();

  const [value] = useState<LocalFormField>(
    localStorage.getItem("form-value") !== null
      ? JSON.parse(localStorage.getItem("form-value") || "")
      : ""
  );

  const [localDescriptions] = useState(value.descriptions);

  const editForm = async () => {
    await localStorage.setItem("edit-form", JSON.stringify(value));
    navigate(`/FormBooking/CityShuttle`, { replace: true });
  };

  const FetchingFailState = () => {
    setTimeout(
      function () {
        setFetchingType("Fail");
        setFetchingText("BOOKING ID NOT FOUND");
      }.bind(this),
      1000
    );
  };

  function openModalOTP() {
    setOTPIsOpen(true);
  }

  function closeModalOTP() {
    setOTPIsOpen(false);
    setOTPError(false);
    setOtpValue("");
  }

  function enableResend() {
    setResendCodeState(false);
    setResendCodeText("RESEND CODE");
  }

  function disableResend() {
    localStorage.setItem("ResendState", "Resended");
    localStorage.setItem(
      "OTPResendTime",
      new Date(new Date().getTime() + 60000).toString()
    );
    setFetchingBooking(false);
    CountDisableResend();
  }

  function CountDisableResend() {
    const localDate = new Date(
      localStorage?.getItem("OTPResendTime") || new Date()
    );

    setResendCodeState(true);

    const checkTime = setInterval(() => {
      let timeleft = localDate.getTime() - new Date().getTime();
      setResendCodeText(
        `WAITING IN 0:${Math.floor((timeleft % (1000 * 60)) / 1000)}`
      );
      if (new Date() >= localDate) {
        enableResend();
        clearInterval(checkTime);
      }
    }, 1000);
  }

  const FunctionResendOTP = async () => {
    setFetchingBooking(true);
    const ResendingOTP = await ResendOTP();
    if (ResendingOTP.status === 200) {
      disableResend();
    } else {
      disableResend();
    }
  };

  const E2EDeleteBooking = (email: string) => {
    axios
      .request({
        method: "DELETE",
        url: `${ApiUrl}/bookings`,
        data: {
          email: email,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log("Succesfully delete");
        }
      })
      .catch((e) => {
        return e;
      });
  };

  const FunctionVerifyOTP = async () => {
    const bookingId = parseInt(localStorage?.getItem("BookingId") || "");
    const verifyingOTP = await verifyOTP(otpValue, bookingId);
    if (verifyingOTP.status === 200) {
      closeModalOTP();
      setIsFechting(true);
      verifyingOTP.data.customer.email === "jdhgd9983@qjwuqxxphu.com" &&
        (await E2EDeleteBooking(verifyingOTP.data.customer.email));
      var paymentLink = verifyingOTP.data.paymentLink;
      setTimeout(
        function () {
          localStorage.clear();
          setFetchingText("Redirect To Payment");
          setFetchingType("Complate");
          window.location.replace(paymentLink);
        }.bind(this),
        1000
      );
    } else {
      setOTPError(true);
    }
  };

  const FunctionOTP = () => {
    setFetchingBooking(false);
    disableResend();
    localStorage.setItem("OTPState", "OTPSended");
    openModalOTP();
  };

  const FunctionReqBooking = async () => {
    closeModal();
    setFetchingBooking(true);

    const reqBookings = await reqBooking(value);

    if (reqBookings.status === 200) {
      localStorage.setItem("BookingId", reqBookings.data.id);
      FunctionOTP();
    } else {
      setFetchingBooking(false);
      setIsError(true);
      setErrorMassage(reqBookings);
    }
  };

  /**
   * CheckBooking is an async function that sets the BookingIdData state to the result of the
   * CheckIdBooking function, which is a function that returns a promise.
   *
   * If the BookingIdData state is true, then the pageState state is set to either "Waiting For
   * Payment" or "waiting" depending on the status of the BookingIdData state.
   *
   * If the BookingIdData state is false, then the pageState state is set to "waiting".
   *
   * If the BookingIdData state is true, then the name, descriptions, and fullAddress states are set to
   * the name, descriptions, and fullAddress of the BookingIdData state.
   */
  const CheckBookingAPI = async () => {
    (await CheckIdBooking(
      params.bookingID || "",
      params.emailAddress || ""
    )) !== "NotFound"
      ? setBookingIdData(
          await CheckIdBooking(
            params.bookingID || "",
            params.emailAddress || ""
          )
        )
      : FetchingFailState();

    BookingIdData
      ? setPageState(
          BookingIdData.bookingStatus === "created" ? "Payment Is Paid" : "-"
        )
      : setPageState("waiting");

    if (BookingIdData) {
      CheckSchedulePrice();
      setTimeout(
        function () {
          setIsFechting(false);
        }.bind(this),
        1000
      );
      setDescriptions(BookingIdData?.bookingLocations[0].description);
      setFullAddressFrom(BookingIdData?.bookingLocations[0].name);
      setFullAddressTo(BookingIdData?.bookingLocations[1].name);
    }
  };

  const CheckBookingLocal = () => {
    if (value) {
      CheckSchedulePrice();
      setPageState("waiting");
      setIsFechting(false);
    } else {
      navigate(`/`, { replace: true });
    }
  };

  const CheckSchedulePrice = async () => {
    var scheduleData = await ScheduleData();
    var totalAdultsPrice = scheduleData.adultPrice * value.adults;
    var totalChildsPrice = scheduleData.childPrice * value.childs;
    setPrice(totalAdultsPrice + totalChildsPrice);
  };

  useEffect(() => {
    params.bookingID ? CheckBookingAPI() : CheckBookingLocal();
    localStorage.getItem("ResendState") !== null && CountDisableResend();
  }, [pageState]);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setIsError(false);
  };

  return (
    <div className="flex justify-center ">
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={ModalStyle}
        contentLabel="Payment"
      >
        <Fade in={true}>
          <div className="flex flex-col px-2 py-2 space-y-5 w-[300px] md:w-[400px]">
            <div className="font-bold text-2xl">Payment</div>
            <div className="font text-justify ">
              Please check your booking data before continue.
            </div>
            <div className="flex items-center justify-end space-x-2">
              <Button
                onClick={() => {
                  closeModal();
                }}
                variant="contained"
                style={{
                  fontWeight: "bold",
                  borderRadius: "10px",
                  fontSize: "13px",
                  backgroundColor: "#ff0000",
                  padding: "8px 30px",
                }}
              >
                Cancel
              </Button>
              <Button
                id="reqBooking"
                onClick={() => {
                  FunctionReqBooking();
                }}
                variant="contained"
                style={{
                  fontWeight: "bold",
                  borderRadius: "10px",
                  fontSize: "13px",
                  backgroundColor: "#384285",
                  padding: "8px 30px",
                }}
              >
                Continue
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
      {!isFetching ? (
        <div className="flex flex-col justify-center items-center  lg:mb-10 mb-0 rounded-0 lg:rounded-[20px] ease-in-out">
          <div className="flex flex-wrap bg-white drop-shadow-xl py-10 px-8 lg:rounded-xl flex-col space-y-12">
            <div className="flex flex-col lg:items-center justify-center font-semibold text-2xl">
              <a className="flex justify-center">
                {pageState == "waiting" ? (
                  " Please Check Your Booking Summary"
                ) : (
                  <div>
                    <a className="text-regal-blue">Thank You,</a> Your Booking
                    is Complate
                  </div>
                )}
              </a>
              {pageState !== "waiting" ? (
                <div className="flex justify-center font-medium">
                  <div>
                    Your Booking ID{" "}
                    <a className="text-regal-blue font-bold ">
                      {` ${BookingIdData?.bookingCode.toUpperCase()}`}
                    </a>{" "}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="flex flex-row flex-wrap w-full text-lg">
              <div className="flex flex-col flex-auto lg:px-10 px-0 space-y-5 mb-10">
                <div className="font-medium py-3 bg-gray-200 rounded-lg flex lg:justify-start justify-center">
                  <div className="lg:ml-8">Personal Information</div>
                </div>
                <div className="grid grid-cols-2 text-base max-w-[500px] gap-2">
                  <a>Name</a>
                  <a>{value ? value.name : BookingIdData?.customer.name}</a>
                  <a>Email</a>
                  <p style={{ overflowWrap: "anywhere" }}>
                    {value ? value.email : BookingIdData?.customer.email}
                  </p>
                  <a>Contact No.</a>
                  <a>
                    {value
                      ? value.contactnumber
                      : BookingIdData?.customer.contact}
                  </a>

                  <a>Guest</a>
                  <div className="flex space-x-5">
                    <a>
                      {value ? value.adults : BookingIdData?.adultTotal} Adults
                    </a>
                    <a>
                      {value
                        ? value?.childs || 0
                        : BookingIdData?.childTotal || 0}{" "}
                      Childs
                    </a>
                  </div>
                  <a>Bags</a>
                  <a>{value ? value.bags : BookingIdData?.numberOfBags} Bags</a>
                  <a>Flight Number</a>
                  <a>
                    {value.flightnumber
                      ? value.flightnumber
                      : BookingIdData?.flightNumber
                      ? BookingIdData?.flightNumber
                      : "-"}
                  </a>
                </div>
                <div style={{ borderTop: "1px solid #bcbcbc " }} />
                <div className="flex flex-col items-center space-y-3">
                  {pageState !== "waiting" ? (
                    <div className="text-regal-blue font-semibold text-2xl ">
                      {`BOOKING IS ${BookingIdData?.bookingStatus.toUpperCase()}`}
                    </div>
                  ) : null}
                  <div className="flex flex-col items-center justify-center space-y-4">
                    <div className="flex">
                      <a>
                        Grand Total:{" "}
                        <a className="text-regal-blue font-semibold text-xl">
                          {`S$${
                            value
                              ? (price / 100).toFixed(2)
                              : (
                                  Number(BookingIdData?.vehicleType.price) / 100
                                ).toFixed(2)
                          }`}
                        </a>
                      </a>
                    </div>
                    {pageState == "waiting" ? (
                      <div className="flex items-center justify-center">
                        <div className="space-x-3">
                          {localStorage.getItem("OTPState") === null ? (
                            <Button
                              id="editBtn"
                              name="editBtn"
                              onClick={() => {
                                editForm();
                              }}
                              variant="contained"
                              style={{
                                fontWeight: "bold",
                                borderRadius: "10px",
                                fontSize: "13px",
                                backgroundColor: "#384285",
                                padding: "8px 30px",
                              }}
                            >
                              EDIT
                            </Button>
                          ) : null}
                          <Button
                            id="payBtn"
                            name="payBtn"
                            onClick={() => {
                              localStorage.getItem("OTPState") === null
                                ? openModal()
                                : openModalOTP();
                            }}
                            variant="contained"
                            style={{
                              fontWeight: "bold",
                              borderRadius: "10px",
                              fontSize: "13px",
                              backgroundColor: "#384285",
                              padding: "8px 30px",
                            }}
                          >
                            Pay Online
                          </Button>{" "}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="flex flex-col flex-auto lg:px-10 px-0 space-y-5">
                <div className="font-medium py-3 bg-gray-200 rounded-lg flex lg:justify-start justify-center">
                  <div className="lg:ml-8">Vehicle Information</div>
                </div>
                {value !== null || BookingIdData?.vehicleType.id !== null ? (
                  <div className="flex flex-wrap space-y-3 justify-evenly items-center">
                    <CityShuttleCard
                      isMainPage={false}
                      scheduleId={value.scheduleId}
                    />
                    {BookingIdData?.bookingStatus == "assigned" ? (
                      <div className="items-start">
                        <div className="grid grid-cols-2 text-base gap-x-[80px] md:gap-x-[50px] gap-y-2">
                          <div>Driver Name</div>
                          <div>
                            <div>{BookingIdData?.driverName}</div>
                          </div>
                          <div>Driver Contact No.</div>
                          <div>
                            <div>{BookingIdData?.driverContact}</div>
                          </div>
                          <div>Plate Number</div>
                          <div>
                            <div>{BookingIdData?.plateNumber}</div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                <div className="font-medium py-3 bg-gray-200 rounded-lg flex lg:justify-start justify-center">
                  <div className="lg:ml-8 ">Summary</div>
                </div>
                <div className="grid grid-cols-2 text-base gap-2">
                  <a>Pick Up DateTime</a>
                  <div className="flex space-x-5">
                    <a>
                      {value
                        ? dayjs(value.date).format("DD/MM/YYYY")
                        : dayjs(BookingIdData?.pickUpTime).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                    </a>
                    <a>{value && dayjs(value.time, "HH:mm").format("HH:mm")}</a>
                  </div>
                  <a>Pick Up</a>
                  <a className="max-w-[300px]">
                    {value
                      ? CheckTerminal(value.from, value.isFromAirport)
                      : fullAddressFrom}
                  </a>
                  {!value.isFromAirport || descriptions ? (
                    <>
                      <a>Descriptions</a>
                      <a className="max-w-[300px]">
                        {value ? localDescriptions : descriptions}
                      </a>
                    </>
                  ) : null}
                  <a>Drop Off</a>
                  <a className="max-w-[300px]">
                    {value
                      ? CheckTerminal(value.to, value.isFromAirport)
                      : fullAddressTo}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Grow in={true}>
          <div className="flex justify-center">
            <Fetching iconType={FetchingType} text={FetchingText}></Fetching>
          </div>
        </Grow>
      )}
      {FetchingBooking && (
        <div className="flex justify-center fixed inset-0 z-50 ">
          <Fetching iconType={FetchingType} text={FetchingText}></Fetching>
        </div>
      )}
      {/* Error Alert */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={isError}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity="error"
          sx={{ width: "100%" }}
        >
          Error: {errorMassage}
        </Alert>
      </Snackbar>
      {/*  */}
      <Modal
        isOpen={modalOTPIsOpen}
        onRequestClose={closeModalOTP}
        style={ModalStyle}
        contentLabel="OTP"
      >
        <Fade in={true}>
          <div className="flex flex-col px-2 py-2 w-[300px] md:w-[450px] justify-center items-center">
            <div className="w-full">
              <div
                onClick={() => {
                  closeModalOTP();
                }}
                className="flex justify-end"
              >
                <img src={xIcon} className="w-[12px]"></img>
              </div>
            </div>
            <div className="space-y-6">
              <div className="flex flex-col items-center space-y-3">
                <div className="font-bold text-xl">Verify Your Account</div>
                <div>
                  <div className="font text-center text-base text-gray-600 ">
                    {`We emailed you the six digit code to ${value.email}`}
                  </div>
                  <div className="font text-center text-base text-gray-600 ">
                    Enter the code below to confirm your email address.
                  </div>
                </div>
              </div>

              <div className="flex flex-col w-full h-full items-center space-y-4">
                {OTPError && <div className="text-red-600">Wrong OTP</div>}
                <OtpInput
                  value={otpValue}
                  onChange={(otp: any) => {
                    setOtpValue(otp.toUpperCase());
                  }}
                  numInputs={6}
                  isInputNum
                  containerStyle="space-x-5 drop-shadow-sm"
                  inputStyle="border border-gray w-10 rounded text-3xl md:text-5xl"
                />
              </div>
              <div className="flex items-center md:flex-row flex-col-reverse justify-between w-full ">
                <div className="flex flex-col space-y-[0px] mt-5 ">
                  <div className="flex text-gray-600 md:justify-start justify-center">
                    Don't receive the code?
                  </div>
                  <Button
                    disabled={resendCodeState}
                    onClick={() => {
                      FunctionResendOTP();
                    }}
                    variant="text"
                    size="small"
                  >
                    {resendCodeText}
                  </Button>
                </div>
                <Button
                  id="verifyOtp"
                  onClick={() => {
                    FunctionVerifyOTP();
                  }}
                  variant="contained"
                  style={{
                    fontWeight: "bold",
                    borderRadius: "10px",
                    fontSize: "13px",
                    backgroundColor: "#384285",
                    padding: "8px 30px",
                  }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ShuttleBookingSummary;
